const features = [
  {
    icon: 'ri-shield-check-line',
    title: '入口实时验证',
    desc: '所有每日大赛入口网址均经过人工与自动化双重验证，确保您访问的是官方正版平台，杜绝钓鱼网站和虚假链接，保障您的账号与信息安全。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-flashlight-line',
    title: '更新即时同步',
    desc: '一旦每日大赛官方发布网址变更、新版本APP或维护通知，我们的监测系统会在第一时间捕获并在本站同步更新，确保信息的时效性和准确性。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-device-line',
    title: '多端全覆盖',
    desc: '无论您使用电脑浏览器还是手机平板，51每日大赛都提供适配各端的访问入口方案，包括Web端官方入口、iOS和Android双平台APP下载方式。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            51每日大赛三大核心优势，为您的每日大赛之旅保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8 text-center hover:border-primary-200 transition-all duration-300"
            >
              <div className={`w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl ${feat.color}`}>
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}